export class UserEventInstallation {
    eventId: number;
    installationName: string;

    constructor() {}

    public parse(obj: any) {
        if (obj.EventId != null) this.eventId = obj.EventId;
        if (obj.InstallationName) this.installationName = obj.InstallationName;
    }
}
